import React from 'react';
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import LocalCafeIcon from '@mui/icons-material/LocalCafe';

interface BuyMeACoffeeProps {
    url?: string;
    size?: 'small' | 'medium' | 'large';
    variant?: 'button' | 'card';
}

export default function BuyMeACoffee({ 
    url = 'https://buymeacoffee.com/loknuslabs',
    size = 'medium',
    variant = 'button'
}: BuyMeACoffeeProps) {
    const handleClick = () => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    if (variant === 'card') {
        return (
            <Card
                variant="outlined"
                sx={{
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: 4,
                        transform: 'translateY(-2px)',
                    },
                    borderColor: 'divider',
                    cursor: 'pointer',
                }}
                onClick={handleClick}
            >
                <CardContent sx={{ p: 2, textAlign: 'center' }}>
                    <LocalCafeIcon 
                        sx={{ 
                            fontSize: size === 'small' ? 32 : size === 'medium' ? 40 : 48,
                            color: '#FF813F',
                            mb: 1
                        }} 
                    />
                    <Typography 
                        variant={size === 'small' ? 'body2' : 'body1'} 
                        sx={{ fontWeight: 600, mb: 0.5 }}
                    >
                        Buy Me a Coffee
                    </Typography>
                    <Typography 
                        variant="caption" 
                        color="text.secondary"
                    >
                        Support development
                    </Typography>
                </CardContent>
            </Card>
        );
    }

    // Button variant
    return (
        <Button
            variant="outlined"
            startIcon={<LocalCafeIcon sx={{ color: '#FF813F' }} />}
            onClick={handleClick}
            size={size}
            sx={{
                textTransform: 'none',
                borderColor: '#FF813F',
                color: '#FF813F',
                '&:hover': {
                    borderColor: '#FF813F',
                    backgroundColor: 'rgba(255, 129, 63, 0.1)',
                },
            }}
        >
            Buy Me a Coffee
        </Button>
    );
}
